import { createClient } from "@sanity/client";

const client = createClient({
  projectId: "vdjrzlwo", // Replace with your Sanity project ID
  dataset: "production", // Replace with your dataset name
  apiVersion: "2023-01-01", // Use a specific API version
  useCdn: true, // `true` for faster response; `false` for the latest data
});

export default client;
